<div [class.notification-horizontal]="authority === Authority.Student || authority === Authority.Substitute">
<!-- WCAG 4.1.3 — landmark for toast stack; new items also announced via LiveAnnouncer in TS -->
<div
  class="notifications-broadcast notifications-position"
  role="region"
  [attr.aria-label]="'NOTIFICATIONS' | translate"
>
    <div class="notification-card notification-radius" *ngFor="let notification of notifications" (click)="goToNotifications(notification)" (keydown.enter)="goToNotifications(notification)" (keydown.space)="$event.preventDefault(); goToNotifications(notification)" role="button" [attr.aria-label]="notification.heading || ('NOTIFICATIONS' | translate)" tabindex="0">
      <div class="notification-icon" aria-hidden="true"><i class="ftmi-notification" aria-hidden="true"></i></div>
      <div class="notification-body">
        <div>
          <span class="notification-title">{{notification.heading}}</span>
          <span class="notification-time">{{notification.created | extendedDate: appConfig.Formats.TimeFormatMidDay}}</span>
        </div>
        <div class="notification-message" [innerHTML]="notification.content | sanitizeHtml">
        </div>
        <div class="notification-link">
          <app-notification-link [notification]="notification"></app-notification-link>
        </div>
      </div>
      <div class="close">
        <button type="button" class="round-btn round-btn-xs" (click)="$event.stopPropagation(); dismiss(notification)" [attr.aria-label]="'CLOSE' | translate">
          <i class="ftmi-cross" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
